import { assign } from 'xstate'
import ApiFetcher from 'lib/api_fetcher'
import {nextStep} from 'utils/step_utils'
import {EUR} from 'utils/currency'
import i18n from 'i18n/config'

const stepName  = 'transferServiceStep'

const setError = assign({error: i18n.t('validations:fill_all_fields')})
const cleanError = assign({error: null})
const setValidationError = assign({error: i18n.t('validations:fill_all_fields')})
const updateForm = assign({transfer_service_form: (ctx, e) => e.form})

const submitForm = (ctx, event) => {
  const formName = 'transfer_service_form'

  return new Promise((resolve, reject) => {
    ctx[formName].submitForm()
      .then(ctx[formName].validateForm)
      .then(errors => {
        const isValid = Object.keys(errors).length === 0
        if (isValid) {
          resolve(ctx[formName].values)
        } else {
          reject(errors)
        }
      })
  })
}

const transferServiceState = (config) => {
  return {
    initial: 'init',
    states: {
      init: {
        on: {'': {
          target: 'waitingQuotationParams',
          actions: cleanError
        }},
      },
      waitingQuotationParams: {},
      formValidation: {
        invoke: {
          src: submitForm,
          onDone: [
            {
              target: '#purchase.' + nextStep(config, stepName),
              actions: assign({transfer_service_values: (ctx, e) => e.data})
            }
          ],
          onError: {
            target: 'waitingQuotationParams',
            actions: [setError]
          }
        }
      }
    },
    on: {
      TRANSFER_SERVICE_FORM_CHANGE: {
        actions: [updateForm]
      },
      NEXT_STEP_CLICK: [
        {
          target: '.formValidation'
        },
        {
          actions: [setValidationError]
        }
      ]
    }
  }
}

export default transferServiceState
